var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"meichu2020"}},[_c('Header'),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"container-fluid main"},[_c('router-view')],1),_c('footer',[_c('Footer')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }